interface UpdateItem {
  date: string;
  tag: string;
  title: string;
  desc: string;
}

const updates: UpdateItem[] = [
  {
    date: '2026-07-29',
    tag: '剧集上新',
    title: '《长安十二时辰》第二季全集上线',
    desc: '备受期待的年度古装大剧第二季已完整上线，高清画质无需等待。',
  },
  {
    date: '2026-07-28',
    tag: '电影上线',
    title: '《流浪地球3》超清版独家首发',
    desc: '国产科幻巨制第三部正式登陆嫩草视频，1080P蓝光画质。',
  },
  {
    date: '2026-07-27',
    tag: '综艺更新',
    title: '《奔跑吧》第十二季最新一期同步播出',
    desc: '热门户外真人秀最新一集已上线，欢乐不间断。',
  },
  {
    date: '2026-07-26',
    tag: '动漫追更',
    title: '《凡人修仙传》年番更新至第89集',
    desc: '国漫顶流作品持续更新中，每周两集稳定追更。',
  },
  {
    date: '2026-07-25',
    tag: '平台公告',
    title: '全站播放线路全面升级完成',
    desc: '新增三条高速CDN加速线路，观影流畅度提升40%。',
  },
  {
    date: '2026-07-24',
    tag: '纪录片',
    title: 'BBC《地球脉动》第三季全集中文版上线',
    desc: '顶级自然纪录片中文字幕完整版，4K超清震撼呈现。',
  },
  {
    date: '2026-07-23',
    tag: '韩剧专区',
    title: '《顶楼》系列全集韩语中字完整收录',
    desc: '现象级韩剧全系列已整理完毕，一口气追完三部曲。',
  },
  {
    date: '2026-07-22',
    tag: '美剧更新',
    title: '《曼达洛人》第四季同步更新至第5集',
    desc: '星球大战衍生剧新季热播中，每周同步更新。',
  },
  {
    date: '2026-07-21',
    tag: '专题策划',
    title: '「夏日追剧指南」专题页面正式上线',
    desc: '精选50部暑期必看高分影视剧，分类推荐一网打尽。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
            实时动态
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            每日更新影视资讯，精彩内容不错过
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 hidden md:block"></div>

          <div className="space-y-6">
            {updates.map((item, i) => (
              <div
                key={item.title}
                className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                  i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                  <div className="bg-background-100 rounded-2xl p-5 border border-background-200/80 hover:border-primary-200 transition-colors">
                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-950 mb-1.5">{item.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>

                <div className="hidden md:flex items-center justify-center flex-shrink-0">
                  <div className="w-3 h-3 rounded-full bg-primary-500 border-4 border-background-50 ring-4 ring-background-200/60"></div>
                </div>

                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}